export class SellerError extends Error {}
